<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { InputText } from '@fno/component2/form.js'

    export let context
    export let formKey
    export let index
</script>

<Card>
    <CardBody>
        <Row>
            <Col>
                <InputText
                    label="First Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.firstname"
                    bind:value={context.form[formKey][index].attributes.firstname}
                    on:change
                />
            </Col>
            <Col>
                <InputText
                    label="Last Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.lastname"
                    bind:value={context.form[formKey][index].attributes.lastname}
                    on:change
                />
            </Col>
        </Row>
        <Row>
            <Col>
                <InputText
                    label="Email"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.email"
                    bind:value={context.form[formKey][index].attributes.email}
                    on:change
                />
            </Col>
            <Col>
                <InputText
                    label="Phone Number"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.phoneNumber"
                    bind:value={context.form[formKey][index].attributes.phoneNumber}
                    on:change
                />
            </Col>
        </Row>
    </CardBody>
</Card>
